__turbopack_context__.v({
  "controls": "B2aHuG_controls",
  "mobileCloseButton": "B2aHuG_mobileCloseButton",
  "primaryButton": "B2aHuG_primaryButton",
  "root": "B2aHuG_root",
  "secondaryButton": "B2aHuG_secondaryButton",
  "title": "B2aHuG_title",
});
